function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { useMutation, request, useQuery } from '@applyboard/ui-utils';
import { isEqual } from 'lodash';
import { Classifications } from "./requirementClassifications";
export function useCreateApplicationRequirement() {
  var _useMutation = useMutation( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
        var response, newRequirementId;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return request("/api/applications/".concat(params.applicationId, "/application_requirements"), {
                method: 'POST',
                contentType: 'application/vnd.api+json',
                body: {
                  data: {
                    attributes: _objectSpread(_objectSpread({}, getCommonAttributesFromRequirement(params.requirement)), {}, {
                      application_questions: getQuestions(params.requirement),
                      application_requirement_type: params.requirement.requirementTemplateType,
                      currency_amount: {
                        currency: params.requirement.receiptCurrency,
                        amount: params.requirement.receiptAmount,
                        key: -1
                      }
                    })
                  }
                },
                // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                isExpectedResponse: function isExpectedResponse(res) {
                  var _res$data, _res$data2;
                  return typeof (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.id) === 'string' && typeof (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.type) === 'string' && !(res !== null && res !== void 0 && res.included) || Array.isArray(res.included);
                }
              });
            case 2:
              response = _context.sent;
              newRequirementId = response.data.id;
              _context.next = 6;
              return Promise.all(params.requirement.externalLinks.map(function (_ref2) {
                var link = _ref2.link;
                return request("/api/application_requirements/".concat(newRequirementId, "/application_external_links"), {
                  method: 'POST',
                  contentType: 'application/vnd.api+json',
                  body: {
                    data: {
                      attributes: {
                        link: link
                      }
                    }
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return _typeof(res) === 'object';
                  }
                });
              }));
            case 6:
              _context.next = 8;
              return Promise.all(params.requirement.files.map(function (file) {
                return request("/api/application_requirements/".concat(newRequirementId, "/application_additional_attachments"), {
                  method: 'POST',
                  body: file,
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return _typeof(res) === 'object';
                  }
                });
              }));
            case 8:
              return _context.abrupt("return", {
                /**
                 * @deprecated Please don't use this
                 */
                legacyResponse: response
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()),
    mutate = _useMutation.mutate,
    isLoading = _useMutation.isLoading;
  return {
    createApplicationRequirement: mutate,
    isCreatingApplicationRequirement: isLoading
  };
}
export function useCreateRequirementTemplate() {
  var _useMutation2 = useMutation( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(requirement) {
        var response, newRequirementTemplateId;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return request('/api/requirement_templates', {
                method: 'POST',
                contentType: 'application/vnd.api+json',
                body: {
                  data: {
                    attributes: _objectSpread(_objectSpread({}, getCommonAttributesFromRequirement(requirement)), {}, {
                      questions: getQuestions(requirement),
                      requirement_template_type: requirement.requirementTemplateType,
                      currency_amounts: [{
                        currency: requirement.receiptCurrency,
                        amount: requirement.receiptAmount,
                        key: -1
                      }]
                    })
                  }
                },
                // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                isExpectedResponse: function isExpectedResponse(res) {
                  var _res$data3;
                  return typeof (res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.id) === 'string';
                }
              });
            case 2:
              response = _context2.sent;
              newRequirementTemplateId = response.data.id;
              _context2.next = 6;
              return Promise.all(requirement.externalLinks.map(function (_ref4) {
                var link = _ref4.link;
                return request("/api/requirement_templates/".concat(newRequirementTemplateId, "/external_links"), {
                  method: 'POST',
                  contentType: 'application/vnd.api+json',
                  body: {
                    data: {
                      attributes: {
                        link: link,
                        requirement_template_type: requirement.requirementTemplateType
                      }
                    }
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return _typeof(res) === 'object';
                  }
                });
              }));
            case 6:
              _context2.next = 8;
              return Promise.all(requirement.files.map(function (file) {
                return request("/api/requirement_templates/".concat(newRequirementTemplateId, "/additional_attachments"), {
                  method: 'POST',
                  body: file,
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return _typeof(res) === 'object';
                  }
                });
              }));
            case 8:
              return _context2.abrupt("return", {
                id: newRequirementTemplateId
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }()),
    mutate = _useMutation2.mutate,
    isLoading = _useMutation2.isLoading;
  return {
    createRequirementTemplate: mutate,
    isCreatingRequirementTemplate: isLoading
  };
}
export function useUpdateLegacyRequirementTemplate() {
  var _useMutation3 = useMutation( /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref5) {
        var requirementId, requirement, oldExternalLinks, oldFiles, oldQuestions, linksToDelete, linksToCreate, filesToDelete, filesToCreate, questionsToUpdate, questionsToAdd, questionsToDelete;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              requirementId = _ref5.requirementId, requirement = _ref5.requirement, oldExternalLinks = _ref5.oldExternalLinks, oldFiles = _ref5.oldFiles, oldQuestions = _ref5.oldQuestions;
              _context3.next = 3;
              return request("/api/requirement_templates/".concat(requirementId), {
                method: 'PATCH',
                contentType: 'application/vnd.api+json',
                body: {
                  data: {
                    attributes: _objectSpread(_objectSpread({}, getCommonAttributesFromRequirement(requirement)), {}, {
                      questions: getQuestions(requirement),
                      requirement_template_type: requirement.requirementTemplateType,
                      currency_amounts: [{
                        currency: requirement.receiptCurrency,
                        amount: requirement.receiptAmount,
                        key: -1
                      }]
                    })
                  }
                },
                // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                isExpectedResponse: function isExpectedResponse(res) {
                  var _res$data4;
                  return typeof (res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.id) === 'string';
                }
              });
            case 3:
              linksToDelete = getLinksToDelete({
                oldExternalLinks: oldExternalLinks,
                newExternalLinks: requirement.externalLinks
              });
              _context3.next = 6;
              return Promise.all(linksToDelete.map(function (_ref7) {
                var id = _ref7.id;
                return request("/api/requirement_templates/".concat(requirementId, "/external_links/").concat(id, "?type=document_requirement_templates"), {
                  method: 'DELETE',
                  contentType: 'application/vnd.api+json',
                  body: {
                    id: id,
                    template_id: requirementId,
                    type: 'document_requirement_templates'
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return true;
                  }
                });
              }));
            case 6:
              linksToCreate = (requirement.externalLinks || []).filter(function (_ref8) {
                var id = _ref8.id;
                return !id;
              });
              _context3.next = 9;
              return Promise.all(linksToCreate.map(function (_ref9) {
                var link = _ref9.link;
                return request("/api/requirement_templates/".concat(requirementId, "/external_links"), {
                  method: 'POST',
                  contentType: 'application/vnd.api+json',
                  body: {
                    data: {
                      attributes: {
                        link: link,
                        requirement_template_type: requirement.requirementTemplateType
                      }
                    }
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return _typeof(res) === 'object';
                  }
                });
              }));
            case 9:
              filesToDelete = getFilesToDelete({
                oldFiles: oldFiles,
                newFiles: requirement.files
              });
              _context3.next = 12;
              return Promise.all(filesToDelete.map(function (_ref10) {
                var id = _ref10.id;
                return request("/api/requirement_templates/".concat(requirementId, "/additional_attachments/").concat(id, "?type=document_requirement_templates"), {
                  method: 'DELETE',
                  contentType: 'application/vnd.api+json',
                  body: {
                    id: id,
                    template_id: requirementId,
                    type: 'document_requirement_templates'
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return true;
                  }
                });
              }));
            case 12:
              filesToCreate = (requirement.files || []).filter(function (file) {
                return file instanceof File;
              });
              _context3.next = 15;
              return Promise.all(filesToCreate.map(function (file) {
                return request("/api/requirement_templates/".concat(requirementId, "/additional_attachments"), {
                  method: 'POST',
                  body: file,
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return _typeof(res) === 'object';
                  }
                });
              }));
            case 15:
              questionsToUpdate = getQuestionsToUpdate({
                oldQuestions: oldQuestions,
                newQuestions: requirement.questions
              });
              _context3.next = 18;
              return Promise.all(questionsToUpdate.map(function (question) {
                return request("/api/requirement_templates/".concat(requirementId, "/questions/").concat(question.id), {
                  method: 'PATCH',
                  contentType: 'application/vnd.api+json',
                  body: {
                    data: {
                      attributes: {
                        question: question.question,
                        question_format: question.questionFormat,
                        options: question === null || question === void 0 ? void 0 : question.options,
                        id: question.id
                      }
                    }
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return true;
                  }
                });
              }));
            case 18:
              questionsToAdd = (requirement.questions || []).filter(function (question) {
                return !(question !== null && question !== void 0 && question.id);
              });
              _context3.next = 21;
              return Promise.all(questionsToAdd.map(function (question) {
                return request("/api/requirement_templates/".concat(requirementId, "/questions"), {
                  method: 'POST',
                  contentType: 'application/vnd.api+json',
                  body: {
                    data: {
                      attributes: {
                        requirement_template_type: 'questions',
                        question_format: question.questionFormat,
                        question: question.question,
                        options: question === null || question === void 0 ? void 0 : question.options
                      }
                    }
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return _typeof(res) === 'object';
                  }
                });
              }));
            case 21:
              questionsToDelete = getQuestionsToDelete({
                oldQuestions: oldQuestions,
                newQuestions: requirement.questions
              });
              _context3.next = 24;
              return Promise.all(questionsToDelete.map(function (_ref11) {
                var id = _ref11.id;
                return request("/api/requirement_templates/".concat(requirementId, "/questions/").concat(id, "?type=questions_requirement_templates"), {
                  method: 'DELETE',
                  contentType: 'application/vnd.api+json',
                  body: {
                    id: id,
                    template_id: requirementId,
                    type: 'questions_requirement_templates'
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return true;
                  }
                });
              }));
            case 24:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }()),
    mutate = _useMutation3.mutate,
    isLoading = _useMutation3.isLoading;
  return {
    updateRequirementTemplate: mutate,
    isUpdatingRequirementTemplate: isLoading
  };
}
function getQuestions(requirement) {
  if (requirement.requirementTemplateType !== 'questions') {
    return null;
  }
  return requirement.questions.map(function (question) {
    return {
      question: question.question,
      question_format: question.questionFormat,
      options: question.options
    };
  });
}
function getCommonAttributesFromRequirement(requirement) {
  var convertToNumber = function convertToNumber(value) {
    return value !== null ? Number(value) : null;
  };
  var validationRules = requirement.maxPlagiarismScore ? {
    plagiarism: {
      max_word_count: convertToNumber(requirement.maxPlagiarismWordCount),
      min_word_count: convertToNumber(requirement.minPlagiarismWordCount),
      max_char_count: convertToNumber(requirement.maxPlagiarismCharCount),
      min_char_count: convertToNumber(requirement.minPlagiarismCharCount),
      max_plagiarism_score: convertToNumber(requirement.maxPlagiarismScore)
    }
  } : {};
  return {
    amount: requirement.amount,
    application_stage: requirement.stage,
    applyboard_requirement: requirement.applyboardRequirement,
    applyproof_compatible: requirement.applyproofCompatible,
    collect_by_applyboard: false,
    description: requirement.description,
    ewallet_credit: false,
    file_types: requirement.fileTypes,
    file_categories: requirement.fileCategories,
    file_upload_limit: requirement.fileUploadLimit,
    flywire: requirement.flywire,
    internal_description: requirement.internalDescription,
    internal_title: requirement.internalTitle,
    classification: requirement.classification,
    official: requirement.official,
    early_access: requirement.earlyAccess,
    // Only available on requirement templates
    optional: requirement.optional,
    payment_requirement_category_id: requirement.paymentRequirementCategoryId,
    receipt_upload: true,
    requirement_category: requirement.requirementCategory,
    requires_notarization: requirement.requiresNotarization,
    validation_rules: validationRules,
    // Only available on requirement templates
    title: requirement.title,
    currency: requirement.currency,
    evaluation_recipe_id: requirement.evaluationRecipeId
  };
}
function getLinksToDelete(_ref12) {
  var _ref12$oldExternalLin = _ref12.oldExternalLinks,
    oldExternalLinks = _ref12$oldExternalLin === void 0 ? [] : _ref12$oldExternalLin,
    _ref12$newExternalLin = _ref12.newExternalLinks,
    newExternalLinks = _ref12$newExternalLin === void 0 ? [] : _ref12$newExternalLin;
  return oldExternalLinks.filter(function (externalLink) {
    return !newExternalLinks.find(function (_ref13) {
      var id = _ref13.id;
      return externalLink.id === id;
    });
  });
}
function getFilesToDelete(_ref14) {
  var _ref14$oldFiles = _ref14.oldFiles,
    oldFiles = _ref14$oldFiles === void 0 ? [] : _ref14$oldFiles,
    _ref14$newFiles = _ref14.newFiles,
    newFiles = _ref14$newFiles === void 0 ? [] : _ref14$newFiles;
  // Get the list of file IDs that the user kept
  var keptFileIds = newFiles.map(function (file) {
    return file instanceof File ? false : file.id.toString();
  }).filter(Boolean);

  // Take the oldFiles and filter out the ones the user kept.  We need to delete
  // the files the user did not keep.
  return oldFiles.filter(function (file) {
    if (file instanceof File) {
      return false;
    }
    return !keptFileIds.includes(file.id.toString());
  });
}
function getQuestionsToDelete(_ref15) {
  var _ref15$oldQuestions = _ref15.oldQuestions,
    oldQuestions = _ref15$oldQuestions === void 0 ? [] : _ref15$oldQuestions,
    _ref15$newQuestions = _ref15.newQuestions,
    newQuestions = _ref15$newQuestions === void 0 ? [] : _ref15$newQuestions;
  return oldQuestions.filter(function (question) {
    return !newQuestions.find(function (_ref16) {
      var id = _ref16.id;
      return question.id === id;
    });
  });
}
function getQuestionsToUpdate(_ref17) {
  var _ref17$oldQuestions = _ref17.oldQuestions,
    oldQuestions = _ref17$oldQuestions === void 0 ? [] : _ref17$oldQuestions,
    _ref17$newQuestions = _ref17.newQuestions,
    newQuestions = _ref17$newQuestions === void 0 ? [] : _ref17$newQuestions;
  return newQuestions.filter(function (newQuestion) {
    var oldQuestion = oldQuestions.find(function (_ref18) {
      var id = _ref18.id;
      return newQuestion.id === id;
    });
    if (!oldQuestion) {
      return false;
    }
    if (newQuestion.question !== oldQuestion.question) {
      return true;
    }
    if (newQuestion.questionFormat === 'dropdown' || newQuestion.questionFormat === 'checkboxes') {
      return !isEqual(newQuestion.options, oldQuestion.options);
    }
    return false;
  });
}
export function useLegacyApplicationRequirement(id) {
  var queryKey = ['application_requirement', {
    id: id,
    pkg: 'ab-application-legacy'
  }];
  var _useQuery = useQuery(queryKey, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _response$data$attrib, _response$data$attrib2, _response$data$attrib3, _response$data$attrib4, _response$data$attrib5, _response$data$attrib6, _response$data$attrib7, _response$data$attrib8, _response$data$attrib9, _response$data$attrib10, _response$data$attrib11, _response$data$attrib12, _response$data$attrib13, _response$data$attrib14, _response$data$attrib15, _response$data$attrib16, _response$data$attrib17, _response$data$attrib18, _response$included$fi, _response$included, _response$included$fi2, _response$included$fi3, _response$included2, _response$included2$f, _response$included$fi4, _response$included3, _response$included3$f, _response$data$attrib19, _response$data$attrib20, _response$data$attrib21, _response$data$attrib22, _response$data$attrib23, _response$data$attrib24, _response$data$attrib25, _response$data$attrib26;
      var url, response, receiptCurrency, currencyAmounts, receiptAmount;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            // eslint-disable-next-line max-len
            url = "/api/application_requirements/".concat(id, "?include=application_additional_attachments,application_external_links,application_questions");
            _context4.next = 3;
            return request(url, {
              // eslint-disable-next-line no-restricted-syntax, @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any -- TODO: Refactor this to use `schema`
              isExpectedResponse: function isExpectedResponse(res) {
                return _typeof(res === null || res === void 0 ? void 0 : res.data) === 'object';
              }
            });
          case 3:
            response = _context4.sent;
            receiptCurrency = (_response$data$attrib = response.data.attributes) === null || _response$data$attrib === void 0 ? void 0 : (_response$data$attrib2 = _response$data$attrib.currency_amount) === null || _response$data$attrib2 === void 0 ? void 0 : _response$data$attrib2.currency;
            currencyAmounts = (_response$data$attrib3 = response.data.attributes) === null || _response$data$attrib3 === void 0 ? void 0 : (_response$data$attrib4 = _response$data$attrib3.currency_amount) === null || _response$data$attrib4 === void 0 ? void 0 : _response$data$attrib4.amount_cents;
            receiptAmount = currencyAmounts || currencyAmounts === 0 ? ((_response$data$attrib5 = response.data.attributes) === null || _response$data$attrib5 === void 0 ? void 0 : _response$data$attrib5.currency_amount.amount_cents) / 100 : null;
            return _context4.abrupt("return", {
              data: {
                id: response.data.id,
                title: response.data.attributes.title,
                internalTitle: response.data.attributes.internal_title,
                requirementCategoryDisplayName: response.data.attributes.requirement_category_display_name,
                stage: response.data.attributes.application_stage,
                applicationStage: response.data.attributes.application_stage,
                requirementTemplateType: response.data.attributes.requirement_template_type,
                classification: response.data.attributes.classification,
                optional: response.data.attributes.optional,
                applyboardRequirement: response.data.attributes.applyboard_requirement,
                active: response.data.attributes.active,
                applyproofCompatible: response.data.attributes.applyproof_compatible,
                official: response.data.attributes.official,
                internalDescription: response.data.attributes.internal_description,
                description: response.data.attributes.description,
                requirementCategory: response.data.attributes.requirement_category,
                requiresNotarization: response.data.attributes.requires_notarization,
                maxPlagiarismScore: (_response$data$attrib6 = response.data.attributes.validation_rules) === null || _response$data$attrib6 === void 0 ? void 0 : (_response$data$attrib7 = _response$data$attrib6.plagiarism) === null || _response$data$attrib7 === void 0 ? void 0 : _response$data$attrib7.max_plagiarism_score,
                maxPlagiarismWordCount: (_response$data$attrib8 = response.data.attributes.validation_rules) === null || _response$data$attrib8 === void 0 ? void 0 : (_response$data$attrib9 = _response$data$attrib8.plagiarism) === null || _response$data$attrib9 === void 0 ? void 0 : _response$data$attrib9.max_word_count,
                minPlagiarismWordCount: (_response$data$attrib10 = response.data.attributes.validation_rules) === null || _response$data$attrib10 === void 0 ? void 0 : (_response$data$attrib11 = _response$data$attrib10.plagiarism) === null || _response$data$attrib11 === void 0 ? void 0 : _response$data$attrib11.min_word_count,
                maxPlagiarismCharCount: (_response$data$attrib12 = response.data.attributes.validation_rules) === null || _response$data$attrib12 === void 0 ? void 0 : (_response$data$attrib13 = _response$data$attrib12.plagiarism) === null || _response$data$attrib13 === void 0 ? void 0 : _response$data$attrib13.max_char_count,
                minPlagiarismCharCount: (_response$data$attrib14 = response.data.attributes.validation_rules) === null || _response$data$attrib14 === void 0 ? void 0 : (_response$data$attrib15 = _response$data$attrib14.plagiarism) === null || _response$data$attrib15 === void 0 ? void 0 : _response$data$attrib15.min_char_count,
                fileTypes: response.data.attributes.file_types,
                fileCategories: response.data.attributes.file_categories,
                flywire: (_response$data$attrib16 = response.data.attributes) === null || _response$data$attrib16 === void 0 ? void 0 : _response$data$attrib16.flywire,
                fileUploadLimit: (_response$data$attrib17 = response.data.attributes) === null || _response$data$attrib17 === void 0 ? void 0 : _response$data$attrib17.file_upload_limit,
                estimatatedTimeUntilPrepared: (_response$data$attrib18 = response.data.attributes) === null || _response$data$attrib18 === void 0 ? void 0 : _response$data$attrib18.estimatated_time_until_prepared,
                externalLinks: (_response$included$fi = response === null || response === void 0 ? void 0 : (_response$included = response.included) === null || _response$included === void 0 ? void 0 : (_response$included$fi2 = _response$included.filter(function (item) {
                  return item.type === 'application_external_links';
                })) === null || _response$included$fi2 === void 0 ? void 0 : _response$included$fi2.map(function (link) {
                  return {
                    id: link.id,
                    link: link.attributes.link
                  };
                })) !== null && _response$included$fi !== void 0 ? _response$included$fi : [],
                questions: (_response$included$fi3 = response === null || response === void 0 ? void 0 : (_response$included2 = response.included) === null || _response$included2 === void 0 ? void 0 : (_response$included2$f = _response$included2.filter(function (item) {
                  return item.type === 'application_questions';
                })) === null || _response$included2$f === void 0 ? void 0 : _response$included2$f.map(function (question) {
                  return {
                    id: question.id,
                    question: question.attributes.question,
                    questionFormat: question.attributes.question_format,
                    options: question.attributes.options
                  };
                })) !== null && _response$included$fi3 !== void 0 ? _response$included$fi3 : [],
                files: (_response$included$fi4 = response === null || response === void 0 ? void 0 : (_response$included3 = response.included) === null || _response$included3 === void 0 ? void 0 : (_response$included3$f = _response$included3.filter(function (item) {
                  var _item$attributes;
                  return item.type === 'application_additional_attachments' && (item === null || item === void 0 ? void 0 : (_item$attributes = item.attributes) === null || _item$attributes === void 0 ? void 0 : _item$attributes.file_size);
                })) === null || _response$included3$f === void 0 ? void 0 : _response$included3$f.map(function (file) {
                  return {
                    id: file.id,
                    name: file.attributes.file_name,
                    size: file.attributes.file_size,
                    type: file.attributes.content_type,
                    link: file.attributes.link
                  };
                })) !== null && _response$included$fi4 !== void 0 ? _response$included$fi4 : [],
                amount: (_response$data$attrib19 = response.data.attributes) !== null && _response$data$attrib19 !== void 0 && _response$data$attrib19.amount_cents || ((_response$data$attrib20 = response.data.attributes) === null || _response$data$attrib20 === void 0 ? void 0 : _response$data$attrib20.amount_cents) === 0 ? response.data.attributes.amount_cents / 100 : null,
                currency: (_response$data$attrib21 = response.data.attributes) === null || _response$data$attrib21 === void 0 ? void 0 : _response$data$attrib21.currency,
                paymentRequirementCategoryId: (_response$data$attrib22 = response.data.attributes) === null || _response$data$attrib22 === void 0 ? void 0 : _response$data$attrib22.payment_requirement_category_id,
                receiptCurrency: receiptCurrency,
                receiptAmount: receiptAmount,
                earlyAccess: (_response$data$attrib23 = response.data.attributes) === null || _response$data$attrib23 === void 0 ? void 0 : _response$data$attrib23.early_access,
                amountCanBeUpdated: (_response$data$attrib24 = response.data.attributes) === null || _response$data$attrib24 === void 0 ? void 0 : _response$data$attrib24.amount_can_be_updated,
                classificationCanBeUpdated: (_response$data$attrib25 = response.data.attributes) === null || _response$data$attrib25 === void 0 ? void 0 : _response$data$attrib25.classification_can_be_updated,
                requirementTemplateId: (_response$data$attrib26 = response.data.attributes) === null || _response$data$attrib26 === void 0 ? void 0 : _response$data$attrib26.requirement_template_id
              }
            });
          case 8:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))),
    isFetching = _useQuery.isFetching,
    isFetched = _useQuery.isFetched,
    data = _useQuery.data;
  var applicationRequirement = (data === null || data === void 0 ? void 0 : data.data) || null;
  return {
    applicationRequirement: applicationRequirement,
    isFetchingApplicationRequirement: isFetching,
    isApplicationRequirementFetched: isFetched
  };
}
export function useUpdateLegacyApplicationRequirement() {
  var _useMutation4 = useMutation( /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref20) {
        var requirementId, requirement, oldExternalLinks, oldFiles, oldQuestions, response, linksToDelete, linksToCreate, filesToDelete, filesToCreate, questionsToUpdate, questionsUpdated, questionsToAdd, questionsToDelete;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              requirementId = _ref20.requirementId, requirement = _ref20.requirement, oldExternalLinks = _ref20.oldExternalLinks, oldFiles = _ref20.oldFiles, oldQuestions = _ref20.oldQuestions;
              _context5.next = 3;
              return request("/api/application_requirements/".concat(requirementId), {
                method: 'PATCH',
                contentType: 'application/vnd.api+json',
                body: {
                  data: {
                    attributes: {
                      id: requirementId,
                      title: requirement.title,
                      description: requirement.description,
                      classification: requirement.classification,
                      applyboard_requirement: requirement.applyboardRequirement,
                      internal_title: requirement.internalTitle,
                      internal_description: requirement.internalDescription,
                      applyproof_compatible: requirement.applyproofCompatible,
                      official: requirement.official,
                      payment_requirement_category_id: requirement.paymentRequirementCategoryId,
                      optional: requirement.optional,
                      requires_notarization: requirement.requiresNotarization,
                      validation_rules: {
                        plagiarism: {
                          max_word_count: requirement.maxPlagiarismWordCount,
                          min_word_count: requirement.minPlagiarismWordCount,
                          max_char_count: requirement.maxPlagiarismCharCount,
                          min_char_count: requirement.minPlagiarismCharCount,
                          max_plagiarism_score: requirement.maxPlagiarismScore
                        }
                      },
                      file_upload_limit: requirement.fileUploadLimit,
                      amount: requirement.amount,
                      currency: requirement.currency,
                      file_types: requirement.fileTypes,
                      file_categories: requirement.fileCategories,
                      flywire: requirement.flywire,
                      application_additional_attachments: requirement.files.filter(function (_ref22) {
                        var id = _ref22.id;
                        return id;
                      }).map(function (file) {
                        return {
                          content_type: file.type,
                          file_name: file.name,
                          file_size: file.size,
                          id: file.id,
                          link: file.link
                        };
                      }),
                      application_external_links: requirement.externalLinks.filter(function (_ref23) {
                        var id = _ref23.id;
                        return id;
                      }),
                      questions: requirement.questions.filter(function (_ref24) {
                        var id = _ref24.id;
                        return id;
                      }),
                      currency_amount: requirement.receiptAmount && requirement.receiptCurrency ? {
                        amount_cents: parseFloat(requirement.receiptAmount.toString()) * 100,
                        currency: requirement.receiptCurrency,
                        amount: requirement.receiptAmount
                      } : null,
                      evaluation_recipe_id: requirement.evaluationRecipeId
                    }
                  }
                },
                // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                isExpectedResponse: function isExpectedResponse(res) {
                  var _res$data5, _res$data6;
                  return typeof (res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.id) === 'string' && typeof (res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.type) === 'string' && !(res !== null && res !== void 0 && res.included) || Array.isArray(res.included);
                }
              });
            case 3:
              response = _context5.sent;
              linksToDelete = getLinksToDelete({
                oldExternalLinks: oldExternalLinks,
                newExternalLinks: requirement.externalLinks
              });
              _context5.next = 7;
              return Promise.all(linksToDelete.map(function (_ref25) {
                var id = _ref25.id;
                return request( // eslint-disable-next-line max-len
                "/api/application_requirements/".concat(requirementId, "/application_external_links/").concat(id), {
                  method: 'DELETE',
                  contentType: 'application/vnd.api+json',
                  body: {
                    id: id,
                    application_requirement_id: requirementId
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return true;
                  }
                });
              }));
            case 7:
              linksToCreate = (requirement.externalLinks || []).filter(function (_ref26) {
                var id = _ref26.id;
                return !id;
              });
              _context5.next = 10;
              return Promise.all(linksToCreate.map(function (_ref27) {
                var link = _ref27.link;
                return request("/api/application_requirements/".concat(requirementId, "/application_external_links"), {
                  method: 'POST',
                  contentType: 'application/vnd.api+json',
                  body: {
                    data: {
                      attributes: {
                        link: link
                      }
                    }
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return _typeof(res) === 'object';
                  }
                });
              }));
            case 10:
              filesToDelete = getFilesToDelete({
                oldFiles: oldFiles,
                newFiles: requirement.files
              });
              _context5.next = 13;
              return Promise.all(filesToDelete.map(function (_ref28) {
                var id = _ref28.id;
                return request( // eslint-disable-next-line max-len
                "/api/application_requirements/".concat(requirementId, "/application_additional_attachments/").concat(id), {
                  method: 'DELETE',
                  contentType: 'application/vnd.api+json',
                  body: {
                    id: id,
                    application_requirement_id: requirementId
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return true;
                  }
                });
              }));
            case 13:
              filesToCreate = (requirement.files || []).filter(function (file) {
                return file instanceof File;
              });
              _context5.next = 16;
              return Promise.all(filesToCreate.map(function (file) {
                return request("/api/application_requirements/".concat(requirementId, "/application_additional_attachments"), {
                  method: 'POST',
                  body: file,
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return _typeof(res) === 'object';
                  }
                });
              }));
            case 16:
              questionsToUpdate = getQuestionsToUpdate({
                oldQuestions: oldQuestions,
                newQuestions: requirement.questions
              });
              _context5.next = 19;
              return Promise.all(questionsToUpdate.map(function (question) {
                return request( // eslint-disable-next-line max-len
                "/api/application_requirements/".concat(requirementId, "/application_questions/").concat(question.id), {
                  method: 'PATCH',
                  contentType: 'application/vnd.api+json',
                  body: {
                    data: {
                      attributes: {
                        question: question.question,
                        question_format: question.questionFormat,
                        options: question === null || question === void 0 ? void 0 : question.options,
                        id: question.id
                      }
                    }
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return true;
                  }
                });
              }));
            case 19:
              questionsUpdated = _context5.sent;
              questionsToAdd = (requirement.questions || []).filter(function (question) {
                return !(question !== null && question !== void 0 && question.id);
              });
              _context5.next = 23;
              return Promise.all(questionsToAdd.map(function (question) {
                return request("/api/application_requirements/".concat(requirementId, "/application_questions"), {
                  method: 'POST',
                  contentType: 'application/vnd.api+json',
                  body: {
                    data: {
                      attributes: {
                        requirement_template_type: 'questions',
                        question_format: question.questionFormat,
                        question: question.question,
                        options: question === null || question === void 0 ? void 0 : question.options
                      }
                    }
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return _typeof(res) === 'object';
                  }
                });
              }));
            case 23:
              questionsToDelete = getQuestionsToDelete({
                oldQuestions: oldQuestions,
                newQuestions: requirement.questions
              });
              _context5.next = 26;
              return Promise.all(questionsToDelete.map(function (_ref29) {
                var id = _ref29.id;
                return request( // eslint-disable-next-line max-len
                "/api/application_requirements/".concat(requirementId, "/application_questions/").concat(id), {
                  method: 'DELETE',
                  contentType: 'application/vnd.api+json',
                  body: {
                    question_id: id,
                    application_requirement_id: requirementId
                  },
                  // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/ban-types -- TODO: Refactor this to use `schema`
                  isExpectedResponse: function isExpectedResponse(res) {
                    return true;
                  }
                });
              }));
            case 26:
              return _context5.abrupt("return", {
                /**
                 * @deprecated Please don't use this
                 */
                legacyQuestions: questionsUpdated,
                /**
                 * @deprecated Please don't use this
                 */
                legacyResponse: response
              });
            case 27:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x4) {
        return _ref21.apply(this, arguments);
      };
    }()),
    mutate = _useMutation4.mutate,
    isLoading = _useMutation4.isLoading;
  return {
    updateApplicationRequirement: mutate,
    isUpdatingApplicationRequirement: isLoading
  };
}
export var isInternalRequirement = function isInternalRequirement(requirement) {
  return requirement.classification !== Classifications.APPLICANT_REQUIREMENTS;
};